<template>
  <div class="systemLogs">
    <ul class="infinite-list" v-infinite-scroll="load" v-if="logsData.length">
      <li v-for="(item, index) in logsData" :key="index" class="item" @click="handleitemClidk(item)">
        <div class="itemHeader">
          <span v-if="item.isRead == 0" class="unreadPoint"></span>
          <span :class="item.isRead == 1 ? '' : 'title'">{{ item.msgTitle }}</span>
          <span class="time">{{ item.createTime }}</span>
        </div>
        <div class="itemcontent">
          <div class="desc" v-html="item.msgContent"></div>
        </div>
      </li>
    </ul>
    <div class="empty" v-if="logsData.length == 0">
      <img src="@/assets/imgs/nodata.png" alt="" />
    </div>
    <p v-if="noMore" class="nomore">没有更多了</p>
  </div>
</template>
  <script>
import store from '@/store';
import { msgCenterpage, msgCentersetSingleRead } from '@/api/userCenter';
import { mapMutations } from 'vuex';
export default {
  data() {
    return {
      logsData: [],
      noMore: false,
      initParam: {
        pageNum: 1,
        pageSize: 10,
        param: {
          userId: '',
          isSystem: '2',
        },
      },
      total: 0,
    };
  },
  methods: {
    ...mapMutations(['user/SET_USER']),
    load() {
      if (this.total > this.initParam.pageNum * this.initParam.pageSize) {
        this.initParam.pageNum += 1;
        this.queryData();
      } else {
        this.noMore = true;
      }
    },
    init() {
      this.queryData();
    },
    async queryData(boolen = false) {
      if (boolen) {
        this.initParam.pageNum = 1;
      }
      this.initParam.param.userId = store.state.user.user.userId;
      let res = await msgCenterpage(this.initParam);
      if (res && Array.isArray(res.list)) {
        this.logsData = res.list.length ? (boolen ? res.list : [...this.logsData, ...res.list]) : this.logsData;
        this.total = res.total;
      } else {
        this.logsData = [];
        this.total = 0;
      }
    },
    async handleitemClidk(detail) {
      if (detail.isRead != 1) {
        let res = await msgCentersetSingleRead({ msgId: detail.msgId, userId: store.state.user.user.userId });
        if (res == 0) {
          this['user/SET_USER']({
            ...this.$store.state.user.user,
            hasMsg: 0,
          });
        }
        await this.queryData(true);
        this.$emit('emitback');
      }
    },
  },
  created() {
    this.init();
  },
};
</script>
  <style lang="less" scoped>
.systemLogs {
  .infinite-list {
    height: 500px;
    overflow-y: auto;
    .item {
      background: #ffffff;
      border: 1px solid #dcdce1;
      margin-bottom: 16px;
      .itemHeader {
        height: 40px;
        line-height: 40px;
        padding: 13px 15px;
        display: flex;
        border-bottom: 1px solid rgba(238, 238, 241, 1);
        .unreadPoint {
          width: 6px;
          height: 6px;
          border-radius: 100%;
          background-color: red;
          margin-right: 5px;
        }
        .title {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #382e2b;
        }
        .time {
          margin-left: auto;
        }
      }
      .itemcontent {
        padding: 15px;
        .desc {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #55555a;
          line-height: 22px;
          /deep/a {
            color: #5788bb;
          }
        }
      }
    }
  }
  .nomore {
    text-align: center;
    color: rgba(87, 136, 187, 1);
    padding: 10px;
  }
  .empty {
    text-align: center;
  }
}
</style>